function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.9105 4.84989C16.855 3.79442 15.1503 3.77364 14.0694 4.80306L5.51974 12.9456C5.04336 13.3993 4.7454 14.0087 4.67994 14.6633L4.25373 18.9255C4.23134 19.1493 4.31061 19.3713 4.46967 19.5304C4.62874 19.6895 4.8508 19.7687 5.07463 19.7464L9.39149 19.3147C10.0003 19.2538 10.5714 18.9916 11.0144 18.5697L19.5332 10.4565C20.652 9.391 20.6737 7.61313 19.5812 6.52062L17.9105 4.84989ZM15.1039 5.88926C15.5952 5.42134 16.3701 5.43079 16.8498 5.91055L18.5205 7.58128C19.0171 8.07788 19.0073 8.886 18.4987 9.37034L17.6957 10.1351L14.2567 6.69607L15.1039 5.88926ZM13.1702 7.73086L6.55422 14.0318C6.33768 14.238 6.20225 14.515 6.1725 14.8126L5.83749 18.1626L9.24223 17.8221C9.51895 17.7944 9.77854 17.6753 9.97992 17.4835L16.6092 11.1699L13.1702 7.73086Z",
  fill: "black",
  fillOpacity: 0.6
});

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.156006a5.svg";
export { ForwardRef as ReactComponent };